import { memo, useCallback, useEffect } from 'react';
import { Box, Flex, useMediaQuery } from '@chakra-ui/react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';

import { FetchModelBlocks, getBlocks, setActiveOverviewTab } from 'redux/ModelsSlice';
import LogoSection from 'pages/ModalOverViewPageHeaderV1/components/LogoSection';
import NavigationBar from 'pages/ModalOverViewPageHeaderV1/components/NavigationBar';
import UserActions from 'pages/ModalOverViewPageHeaderV1/components/UserActions';
import { getUrlValueFromTab } from 'pages/ModalOverViewPageHeaderV1/constants';
import { UserModalNew } from 'pages/UserManagement/ProfileNewUIRevamp';
import { getPlanPageThemeColors, getThemeHeaderConfig } from 'redux/ThemeSlice';

import type { TabType } from 'pages/ModalOverViewPageHeaderV1/types';

const NewHeader = () => {
  const { modelId } = useParams();
  const dispatch: any = useDispatch();
  const navigate = useNavigate();
  const model = useSelector(getBlocks);
  const headerConfig = useSelector(getThemeHeaderConfig);
  const themeColors = useSelector(getPlanPageThemeColors);
  const [isLaptop]: any = useMediaQuery('(max-width: 1024px)');

  useEffect(() => {
    if (modelId && Number(model?.id) !== Number(modelId)) {
      dispatch(FetchModelBlocks({ modelId: Number(modelId) }));
    }
  }, [dispatch, modelId, model?.id]);

  // The plan page lives on /model/:modelId/block/:blockId/plan, so tab clicks
  // navigate back to the model overview route instead of swapping local tabs.
  const handleTabChange = useCallback(
    (tab: TabType) => {
      dispatch(setActiveOverviewTab(tab));
      if (modelId) {
        navigate(`/model/${modelId}/${getUrlValueFromTab(tab)}`);
      }
    },
    [dispatch, modelId, navigate],
  );

  return (
    <>
      <Flex
        as='header'
        w='100%'
        minH={headerConfig.height}
        px={4}
        py='10px'
        alignItems='center'
        justifyContent='space-between'
        gap={2}
        bg={themeColors.surface}
        borderBottom='1px solid'
        borderBottomColor={themeColors.border}
      >
        <Box minW={0}>
          <LogoSection modelName={model?.name} modelData={model} />
        </Box>
        {!isLaptop && (
          <Box display='flex' justifyContent='center'>
            <NavigationBar activeTab='blocks' onTabChange={handleTabChange} />
          </Box>
        )}
        <UserActions />
      </Flex>
      <UserModalNew />
    </>
  );
};

export default memo(NewHeader);
